// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OBiN","content":"styles_content__3CCN2"};